
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop } from "vue-property-decorator";
    import ApiClient from "@/utilities/ApiClient";
    import { VForm } from "@/vForm";
    import * as toastr from "toastr";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import { IBriefing } from "@/model/Briefing";
    import { previewVisitID } from "@/model/Enums";
    import { PathwaySearchParameters } from "@/model/PathwaySearchParameters";
    import { IPathway } from "@/model/Pathway";

    @Component({ components: { ApiButton } })
    export default class ChoosePathwayDialogue extends Vue {

        //
        // -- properties
        //

        @Prop({ default: "Choose Pathway" })
        dialogueTitle!: string

        @Prop({ default: "" })
        dialogueSubTitle!: string

        @Prop({ default: "mdi-circle-medium" })
        itemIcon!: string

        @Ref("briefingForm") readonly briefingForm!: VForm;
        showDialogue: boolean = false;

        briefingID: string = "";
        briefingName: string = "";
        pathwayList: Array<IPathway> = [];

        //
        // -- methods
        //

        async show(briefing: IBriefing): Promise<void> {
            this.pathwayList = [];
            this.briefingID = briefing.id;
            this.briefingName = briefing.name;
            this.showDialogue = true;
            this.loadPathways();
        }

        async loadPathways() {
            const searchParameters = new PathwaySearchParameters();
            searchParameters.briefingID = this.briefingID;
            this.pathwayList = await ApiClient.post("/Api/Pathway/Search", searchParameters);
        }

        select(pathwayID: string): void {
            this.$emit("selected-pathway", pathwayID);
            this.showDialogue = false;
        }

        // print(pathwayID: string): void {
        //     const url = `/briefingPrint/${previewVisitID}?previewPathwayID=${pathwayID}`;
        //     const printWindow = window.open(url);
        //     if(printWindow == null) {
        //         alert("Failed to open pop-up print window.  Do you have a pop-up blocker?");
        //         return;
        //     }
        //     //Close window once print is finished
        //     printWindow.onafterprint = () =>{
        //         printWindow.close();
        //         this.showDialogue = false;
        //     };
        // }
    }
